import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "route_manager"
};
const _hoisted_2 = {
  class: "route_day_layout"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("b", null, "行程列表")], -1);

const _hoisted_4 = {
  id: "route_day",
  class: "route_day"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "day_li"
};
const _hoisted_7 = ["onClick"];

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "添加行程", -1);

const _hoisted_9 = {
  class: "route_details_layout"
};
const _hoisted_10 = {
  class: "route_details_title"
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 2
};
const _hoisted_13 = {
  key: 0,
  class: "programme_room"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "尚未设置", -1);

const _hoisted_15 = {
  key: 1,
  class: "programme_room"
};
const _hoisted_16 = {
  key: 3
};
import DynamicParams from "@com/DynamicParams.vue";
import HotelSelect from "@com/HotelSelect.vue";
import { reactive, ref, onMounted, watch } from "vue";
import Sortable from "sortablejs";
import $ from "@util/base";
import { $msg } from "@/common/ui/msg";
import UploadPicture from "../upload/UploadPicture.vue";
import { Calendar } from "@element-plus/icons-vue";
const type1 = "1008001";
const type2 = "1008002";
const type3 = "1008003";
export default {
  __name: 'RouteManager',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    travelProgramme: {
      type: Array
    }
  },

  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const template = {
      detailType: null,
      detailTitle: null,
      startTime: null,
      hotelItems: props.travelProgramme
    };

    function aaaa() {
      console.log(getValue());
    }

    watch(() => props.data, val => {
      if ($.isNotEmpty(val)) {
        routeData.value = initData();
        sortData.value = routeData.value;
        curDay.value = val[0];
        lastDay = val[0];
      }
    });
    watch(() => props.travelProgramme, val => {
      template.hotelItems = $.deepCopy(val);
    });
    const routeData = reactive({
      value: initData()
    });

    function operation(readOnly) {
      if (readOnly) {
        return {
          move: false,
          modify: false,
          del: false,
          add: true,
          check: false
        };
      } else {
        return {
          move: true,
          modify: false,
          del: true,
          add: false,
          check: false
        };
      }
    }

    function initData() {
      if ($.isNotEmpty(props.data)) {
        return props.data.map(e => {
          e.tempId = $.uuid8();
          return e;
        });
      } else {
        return [];
      }
    }

    if ($.isEmpty(props.data)) {
      addRouteDay();
    }

    const routeDetailsView = ref(null);
    const hotelSelect = ref(null);
    var bindRoomTarget;

    function bindRoom(data) {
      bindRoomTarget = data;
      hotelSelect.value.open();
    }

    function roomSelect(data) {
      bindRoomTarget.hotelName = data.hotelName;
      bindRoomTarget.roomName = data.hotelRoomName;
      bindRoomTarget.hotelCode = data.hotelCode;
      bindRoomTarget.roomCode = data.hotelRoomCode;
    }

    function delDay(id) {
      routeData.value.remove(e => {
        return e.tempId === id;
      });

      if (id == curDay.value.tempId) {
        if (routeData.value.length > 0) {
          curDay.value = routeData.value[0];
        } else {
          curDay.value = [];
        }
      }

      routeData.value.map((e, i) => {
        e.dayNum = i + 1;
      });
    }

    function addRouteDay() {
      let template = {
        title: null,
        dayNum: routeData.value.length + 1,
        tempId: $.uuid8(),
        detailItems: []
      };
      routeData.value.push(template);
    }

    var curDay = reactive({
      value: routeData.value[0]
    });
    var lastDay = routeData.value[0];

    function switchDay(data) {
      if (data.tempId != curDay.value.tempId) {
        let routeDetails = routeDetailsView.value.getValue(); //检查routeDetails数据完整性，是否可以切换天数

        if (check(curDay.value, routeDetails)) {
          //routeDetails数据保证在天数中
          lastDay.detailItems = routeDetails; //切换当前天

          curDay.value = data; //记录上次天

          lastDay = data;
        }
      }
    }

    function check(day, routeDetails) {
      console.log(routeDetails); // if ($.isEmpty(day.title)) {
      //   $msg.error("请填写第" + day.dayNum + "天行程标题")
      //   return false
      // }

      if ($.isEmpty(routeDetails)) {
        $msg.error("请设置第" + day.dayNum + "天行程详情");
        return false;
      }

      for (const item of routeDetails) {
        if ($.isEmpty(item.detailTitle)) {
          $msg.error("请填行程安排写活动标题");
          return false;
        } // if ($.isEmpty(item.startTime)) {
        //   $msg.error("请选择行程安排开始时间");
        //   return false;
        // }


        if (item.detailType == type1) {
          if ($.isEmpty(item.intro)) {
            $msg.error("请填写行程安排活动描述");
            return false;
          }
        } else if (item.detailType == type2) {
          for (const programme of item.hotelItems) {
            if ($.isNull(programme.roomCode)) {
              $msg.error("请填绑定行程安排房间");
              return false;
            }
          }
        } else if (item.detailType == type3) {
          if ($.isEmpty(item.detailTitle)) {
            $msg.error("请填写景点标题");
            return false;
          }

          if ($.isEmpty(item.description)) {
            $msg.error("请填写景点说明");
            return false;
          }

          if (!(item.picUrl != null && item.picUrl.length > 0)) {
            $msg.error("请设置图片");
            return false;
          }
        }
      }

      return true;
    }

    const sortData = reactive({
      value: routeData.value
    });
    onMounted(() => {
      if (!props.readOnly) {
        const ul = document.querySelector("#route_day");
        Sortable.create(ul, {
          handle: ".move",
          animation: 150,
          onEnd: function (evt) {
            const currRow = sortData.value.splice(evt.oldIndex, 1)[0];
            sortData.value.splice(evt.newIndex, 0, currRow);
            routeData.value.map((e, i) => {
              e.dayNum = i + 1;
            });
          }
        });
      }
    });

    function handerData(routeData) {
      for (const day of routeData) {
        delete day.tempId;

        for (const details of day.detailItems) {
          delete details.tempId;

          if (details.detailType == type1) {
            delete details.hotelItems;
          }
        }
      }

      return routeData;
    }

    function getValue() {
      let routeDetails = routeDetailsView.value.getValue();

      if ($.isEmpty(routeDetails)) {
        return null;
      }

      if (check(curDay.value, routeDetails)) {
        curDay.value.detailItems = routeDetails;
        lastDay = curDay.value;
        return handerData($.deepCopy(routeData.value));
      } else {
        return false;
      }
    }

    __expose({
      getValue
    });

    return (_ctx, _cache) => {
      const _component_Rank = _resolveComponent("Rank");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_Close = _resolveComponent("Close");

      const _component_Plus = _resolveComponent("Plus");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routeData.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.tempId,
          class: _normalizeClass({
            active: item.tempId == _unref(curDay).value.tempId
          }),
          onClick: $event => switchDay(item)
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, "第" + _toDisplayString(item.dayNum) + "天", 1), __props.readOnly == false ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "move",
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_component_Rank)]),
          _: 1
        })) : _createCommentVNode("", true)]), __props.readOnly == false ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "del",
          onClick: _withModifiers($event => delDay(item.tempId), ["stop"])
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Close)]),
          _: 1
        })], 8, _hoisted_7)) : _createCommentVNode("", true)], 10, _hoisted_5);
      }), 128))]), __props.readOnly == false ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "dashed_but",
        onClick: addRouteDay
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Plus)]),
        _: 1
      }), _hoisted_8])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("b", null, "第" + _toDisplayString(_unref(curDay).value.dayNum) + "天", 1), _createVNode(_component_el_input, {
        class: "details_title_input",
        modelValue: _unref(curDay).value.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(curDay).value.title = $event),
        placeholder: "请输入行程标题",
        clearable: true,
        disabled: __props.readOnly
      }, null, 8, ["modelValue", "disabled"])]), _createVNode(DynamicParams, {
        ref_key: "routeDetailsView",
        ref: routeDetailsView,
        data: _unref(curDay).value.detailItems,
        template: template,
        operation: operation(__props.readOnly),
        multipleType: true,
        typeProp: "detailType",
        customAdd: "",
        type1Code: type1,
        type2Code: type2,
        type3Code: type3,
        showDefault: false,
        multipleAddText: ['添加活动', '添加住宿安排', '添加景点']
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "活动类容",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            class: "m_b_10",
            modelValue: scope.row.detailTitle,
            "onUpdate:modelValue": $event => scope.row.detailTitle = $event,
            placeholder: "请输入活动标题",
            clearable: true,
            disabled: __props.readOnly
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), scope.row.detailType == type3 ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            class: "m_b_10",
            modelValue: scope.row.description,
            "onUpdate:modelValue": $event => scope.row.description = $event,
            placeholder: "请输入景点描述",
            rows: 4,
            type: "textarea",
            clearable: true,
            disabled: __props.readOnly
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), scope.row.detailType == type1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_input, {
            modelValue: scope.row.intro,
            "onUpdate:modelValue": $event => scope.row.intro = $event,
            rows: 8,
            type: "textarea",
            placeholder: "请输入活动描述",
            clearable: true,
            disabled: __props.readOnly
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])])) : scope.row.detailType == type2 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.hotelItems, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "travel_programme",
              key: item.id
            }, [_createElementVNode("b", null, _toDisplayString(item.packageName) + ":", 1), _unref($).isNull(item.hotelCode) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              text: "",
              onClick: $event => bindRoom(item),
              disabled: __props.readOnly
            }, {
              default: _withCtx(() => [_createTextVNode(" 绑定房型 ")]),
              _: 2
            }, 1032, ["onClick", "disabled"])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", null, _toDisplayString(item.hotelName) + "-" + _toDisplayString(item.roomName), 1), _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              text: "",
              onClick: $event => bindRoom(item),
              disabled: __props.readOnly
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改绑定 ")]),
              _: 2
            }, 1032, ["onClick", "disabled"])]))]);
          }), 128))])) : scope.row.detailType == type3 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(UploadPicture, {
            modelValue: scope.row.picUrl,
            "onUpdate:modelValue": $event => scope.row.picUrl = $event,
            limit: 10,
            imgSize: _unref($).describeImgSize(),
            fileSize: _unref($).imgFileSize(),
            disabled: __props.readOnly
          }, null, 8, ["modelValue", "onUpdate:modelValue", "imgSize", "fileSize", "disabled"])])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "开始时间",
          align: "center",
          width: 130
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            "prefix-icon": _unref(Calendar),
            placeholder: "例 16:30",
            modelValue: scope.row.startTime,
            "onUpdate:modelValue": $event => scope.row.startTime = $event
          }, null, 8, ["prefix-icon", "modelValue", "onUpdate:modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "operation"]), !__props.readOnly ? (_openBlock(), _createBlock(HotelSelect, {
        key: 0,
        title: "绑定房型",
        ref_key: "hotelSelect",
        ref: hotelSelect,
        onSelect: roomSelect
      }, null, 512)) : _createCommentVNode("", true)])]);
    };
  }

};